import request from '@/utils/request'

// 查询首页菜单列表
export function newslist(query) {
  return request({
    url: '/web/menu/newslist',
    method: 'get',
    params: query
  })
}
// 查询新闻详细
export function getNewsInfo(id) {
  return request({
    url: '/web/menu/newslist/' + id,
    method: 'get'
  })
}